import alarmTypeImage from '@/common/images/common/alarmType';

export function getAlarmTypeImage( type: string ): string | undefined {

    switch ( type ) {

        case 'car-index': return alarmTypeImage.alarmCarIndex;

        case 'car-player': return alarmTypeImage.alarmCarPlayer;

        case 'pet-index': return alarmTypeImage.alarmPetIndex;

        case 'pet-player': return alarmTypeImage.alarmPetPlayer;

        case 'person-index': return alarmTypeImage.alarmPersonIndex;

        case 'person-player': return alarmTypeImage.alarmPersonPlayer;

        case 'other-index': return alarmTypeImage.alarmOtherIndex;

        case 'other-player': return alarmTypeImage.alarmOtherPlayer;

        case 'md-index': return alarmTypeImage.alarmMdIndex;

        case 'md-player': return alarmTypeImage.alarmMdPlayer;

        case 'animal-index': return alarmTypeImage.alarmAnimalIndex;

        case 'animal-player': return alarmTypeImage.alarmAnimalPlayer;

        case 'visitor-index': return alarmTypeImage.alarmVisitorIndex;

        case 'visitor-player': return alarmTypeImage.alarmVisitorPlayer;

    }

}
